import {PlayerReduxState} from "../types";
import isIntroStage from "./isIntroStage";
import isResultStage from "./isResultStage";

export default function getDialogueHistory(state: PlayerReduxState): PlayerReduxState["dialogueHistory"] {
  if (isIntroStage(state) || isResultStage(state)) {
    return [];
  }
  return state.dialogueHistory ?? [];
}
